import * as Yup from 'yup';
import { IEmailTemplate, ISMSTemplate } from '@modules/admin/Tools/CustomerCommunications/types';

export enum CommunicationType {
  Text = 1,
  Voicemail = 2,
  Email = 3,
}

export const COMMUNICATION_TYPE_NAME = {
  Text: 'Text',
  Voicemail: 'Voicemail',
  Email: 'Email',
};


export const DEFAULT_EMAIL_DATA: IOneClickCommunicationDataModel[] = [{
	daysRangeBegin : 0,
	daysRangeEnd   : 1,
}, {
	daysRangeBegin : 1,
	daysRangeEnd   : 2,
}, {
	daysRangeBegin : 2,
	daysRangeEnd   : 3,
}, {
	daysRangeBegin : 3,
	daysRangeEnd   : 7,
}, {
	daysRangeBegin : 7,
	daysRangeEnd   : 10,
}, {
	daysRangeBegin : 10,
	daysRangeEnd   : 30,
}].map((item, index) => ({
	...item,
	communicationType : CommunicationType.Email,
	description       : '',
	id                : index.toString(),
	title             : '',
	userId            : null,
	template : null
}));

export const DEFAULT_TEXT_DATA: IOneClickCommunicationDataModel[] = [{
	daysRangeBegin : 0,
	daysRangeEnd   : 1,
}, {
	daysRangeBegin : 1,
	daysRangeEnd   : 2,
}, {
	daysRangeBegin : 2,
	daysRangeEnd   : 3,
}, {
	daysRangeBegin : 3,
	daysRangeEnd   : 7,
}, {
	daysRangeBegin : 7,
	daysRangeEnd   : 10,
}, {
	daysRangeBegin : 10,
	daysRangeEnd   : 20,
}, {
	daysRangeBegin : 20,
	daysRangeEnd   : 30,
}].map((item, index) => ({
	...item,
	communicationType : CommunicationType.Text,
	description       : '',
	id                : index.toString(),
	title             : '',
	userId            : null,
	template : null
}));

export interface IOneClickCommunicationDataModel {
  communicationType: CommunicationType;
  daysRangeBegin: number;
  daysRangeEnd: number;
  description: string;
  id?: string;
  title: string | null;
  userId: string | null;
  template : IEmailTemplate | ISMSTemplate | null
}

export const validationTextSchema = Yup.object().shape({
  description: Yup.string().required(),
});

export const validationEmailSchema = Yup.object().shape({
  title: Yup.string().required(),
  description: Yup.string().required(),
});
